
import Vue, { PropType } from 'vue';
import { RunnitNodeDef, RUNNIT_TYPE, User, Runnit, Avatar } from '@run-diffusion/shared';
import { mapState, mapActions } from 'vuex';
import _shuffle from 'lodash/shuffle';
import { RunnitsCRUDMixin } from '@/mixins';
import GlassButton from '@/components/base/GlassButton.vue';
import TrainingVideoPlayer from '@/components/TrainingVideoPlayer.vue';
import RunnitImage from '@/views/Runnits/RunnitImage.vue';

export default Vue.extend({
	name: 'TrainOnboardingTopCard',
	mixins: [
		RunnitsCRUDMixin,
	],
	props: {
		nodeDef: { type: [Object, String] as PropType<RunnitNodeDef | string>, default: null },
		runnit: { type: [Object, String] as PropType<Runnit | string>, default: null },
		drawerOpen: { type: Boolean, default: false },
		isDismissed: { type: Boolean, default: false },
		persistent: { type: Boolean, default: false },
		isDialog: { type: Boolean, default: false },
	},
	data () {
		return {
			numGridItems: 16,
		};
	},
	computed: {
		...mapState([
			'publicRunnitNodeDefs',
			'loadingPublicRunnitNodeDefs',
			'publicRunnitNodeDefTags',
			'user',
		]),
		onboardingData (): {
			id: string,
			title: string,
			description: string,
			descriptionHtml: string,
			articleUrl: string,
			videoUrl: string,
			avatar: Avatar,
			imageUrl: string,
			articles: { url: string; text: string }[],
		} | null {
			if (typeof this.nodeDef === 'object' && this.nodeDef !== null) {
				const nodeDef = this.nodeDef as RunnitNodeDef;
				const onboardingData = {
					id: nodeDef.id,
					title: nodeDef.title,
					description: nodeDef.description,
					descriptionHtml: nodeDef.onboardingData?.descriptionHtml,
					articleUrl: nodeDef.articleUrl,
					videoUrl: nodeDef.onboardingData?.videoUrl,
					avatar: nodeDef.avatar,
					imageUrl: nodeDef.imageUrl,
					articles: (nodeDef as any).articles || (nodeDef.onboardingData as any)?.articles || [],
				};
				return onboardingData;
			}
			if (typeof this.runnit === 'object' && this.runnit !== null) {
				const runnit = this.runnit as Runnit;
				const onboardingData = {
					id: runnit.id,
					title: runnit.title,
					description: runnit.description,
					descriptionHtml: runnit.onboardingData?.descriptionHtml,
					articleUrl: null,
					videoUrl: runnit.onboardingData?.videoUrl,
					avatar: runnit.avatar,
					imageUrl: null,
					articles: (runnit as any).articles || (runnit.onboardingData as any)?.articles || [],
				};
				return onboardingData;
			}
			return null;
		},
	},
	methods: {
		...mapActions([
			'updateSnackbar',
		]),
		goToArticle (url: string) {
			if (url) {
				window.open(url, '_blank');
			}
		},
		async toggleOnboardingDismissed (nodeDefId: string) {
			if (this.persistent) return;
			this.$emit('toggle-onboarding-dismissed', nodeDefId);
		},
	},
	components: {
		GlassButton,
		TrainingVideoPlayer,
		RunnitImage,
	},
});
